// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"8282e3f2","239":"617bb1d9"}[chunkId] + ".chunk.js";
};